/* eslint-disable max-len */
/* eslint-disable jsx-a11y/label-has-associated-control */
import { useMutation } from '@apollo/client';
import React, { } from 'react';
import useForm from '../../customHooks/useForm';
import useToast from '../../customHooks/useToast';
import { ADMIN_MERCHANT_UPLOAD_DOCUMENT, ADMIN_UPLOAD_DOCUMENT } from '../../graphql/admin_mutations';
import ImageModalComp from '../ImageModalComp';

interface IUploadFile{
  closeModal?: any;
  merchantId?: string;
  documentType?: string;
  fetchKyc?: any;
  uploadDocumentType?:string;
  fetchUser?:any;
  uploadPermissionName?:string;
}
const UploadFile = ({
  closeModal, merchantId, documentType, fetchKyc, uploadDocumentType, fetchUser, uploadPermissionName,
}:IUploadFile) => {
  const [uploadLoading, setUploadLoading] = React.useState(false);
  const [uploadFile, setUploadFile] = React.useState<any>(null);
  const { formValues, handleChange } = useForm({
    documentType: documentType?.toLowerCase?.()?.split?.('_')?.join(' ') || '',
    documentId: '',
  });
  const [checked, setChecked] = React.useState(false);

  const [adminUploadDocument] = useMutation<
    { adminMerchantUpdateDocument: any },
    any
  >(ADMIN_MERCHANT_UPLOAD_DOCUMENT);
  const [adminUploadUserDocument] = useMutation<
  { adminUploadUserDocument: any },
  any
>(ADMIN_UPLOAD_DOCUMENT);
  const Toast = useToast();

  const uploadDocumentFunction = async () => {
    if (!uploadDocumentType) {
      try {
        if (!formValues?.documentType) {
          Toast.error('Document name is required');
          return;
        }
        if (!uploadFile) {
          Toast.error('Please select a file to upload');
          return;
        }
        if (uploadFile?.size > 2000000) {
          Toast.error('File maximum size is 2Mb');
          return;
        }
        setUploadLoading(true);

        const res = await adminUploadDocument({
          variables: {
            file: uploadFile,
            merchantId,
            name: documentType || formValues?.documentType?.trim?.()?.toUpperCase?.()?.split?.(' ')?.join('_') || '',
          },
        });
        if (res?.data?.adminMerchantUpdateDocument?.status === 200) {
          Toast.success(res?.data?.adminMerchantUpdateDocument?.message);
          fetchKyc?.();
          setUploadLoading(false);
          closeModal(false);
          setUploadFile(null);
          return;
        }
        Toast.error(res?.data?.adminMerchantUpdateDocument?.message);
      } catch (e) {
        if (e && e.graphQLErrors && e.graphQLErrors.length > 0) {
          Toast.error(e.graphQLErrors[0].message);
        } else {
          Toast.error('Something went wrong');
        }
      }
      return;
    }
    if (uploadDocumentType === 'admin_user_upload') {
      try {
        if (!formValues?.documentType) {
          Toast.error('Document name is required');
          return;
        }
        if (!uploadFile) {
          Toast.error('Please select a file to upload');
          return;
        }
        if (uploadFile?.size > 2000000) {
          Toast.error('File maximum size is 2Mb');
          return;
        }
        setUploadLoading(true);

        const res = await adminUploadUserDocument({
          variables: {
            file: uploadFile,
            userId: merchantId,
            name: documentType || formValues?.documentType?.trim?.()?.toUpperCase?.()?.split?.(' ')?.join('_') || '',
            provider: checked ? 'IDENTITY_PASS' : undefined,
          },
        });
        if (res?.data?.adminUploadUserDocument?.status === 200) {
          Toast.success(res?.data?.adminUploadUserDocument?.message);
          fetchUser?.({ variables: { id: merchantId } });
          setUploadLoading(false);
          closeModal(false);
          setUploadFile(null);
          return;
        }
        setUploadLoading(false);
        Toast.error(res?.data?.adminUploadUserDocument?.message);
      } catch (e) {
        setUploadLoading(false);
        if (e && e.graphQLErrors && e.graphQLErrors.length > 0) {
          Toast.error(e.graphQLErrors[0].message);
        } else {
          Toast.error('Something went wrong');
        }
      }
      return;
    }

    setUploadLoading(false);
  };

  return (
    <ImageModalComp
      closeModal={closeModal}
      title={documentType ? 'Update document' : 'New Document'}
      text={documentType ? 'Update current document' : 'Upload a new document'}
      uploadFile={uploadFile}
      setUploadFile={setUploadFile}
      viewOnly={!!documentType}
      value={formValues?.documentType}
      handleChange={handleChange}
      uploadLoading={uploadLoading}
      onSubmit={uploadDocumentFunction}
      checked={checked}
      setChecked={setChecked}
      allowIdentityDocument={!documentType && uploadDocumentType === 'admin_user_upload'}
      permissionName={uploadPermissionName}
    />
  );
};
export default UploadFile;
